import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Card, CardContent, CardMedia, Typography, useMediaQuery, useTheme, styled } from '@mui/material';
import { ArrowForwardIos as ArrowForwardIcon } from '@mui/icons-material';
import { recentNewsHome } from '../utils/BeadsData';
import { formatDateSimple } from '../utils/dateUtils';

const StyledCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    margin: theme.spacing(4),
    padding: '.5rem',
    borderRadius: '1rem',
    border: '1px solid #cfcfcf',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        margin: theme.spacing(1),
        marginBottom: theme.spacing(4),
    },
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
}));

const NewsImage = styled(CardMedia)(({ theme }) => ({
    maxWidth: 350,
    height: 250,
    // margin: theme.spacing(2),
    margin: 'auto',
    borderRadius: '1rem',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
        // maxWidth: '90%',
        maxWidth: 'calc(100% - 16px)', // Adjusts the image width to fit within the card with a small margin
        height: 'auto',
    },
}));

const NewsTitle = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    color: 'black',
    '&:hover': {
        color: '#f39c12',
    },
    marginBottom: theme.spacing(2),
}));

const ReadMoreLink = styled(RouterLink)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    marginTop: theme.spacing(1),
    color: theme.palette.primary.main,
    '&:hover': {
        color: '#f39c12',
    },
}));

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(5),
    borderColor: '#007bff',
    color: '#007bff',
    padding: '0.8rem',
    borderRadius: '2rem',
    fontWeight: 'bold',
    '&:hover': {
        backgroundColor: '#f39c12',
        borderColor: '#f39c12',
        color: '#fff',
    },
    transition: 'all 0.3s ease',
}));

const RecentNewsHome = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            <Typography variant="h3" sx={{ mb: 4, fontWeight: 'bolder', textAlign: 'center', mt: 2 }}>
                Recent News
            </Typography>

            {recentNewsHome.map((item) => (
                <StyledCard key={item.id}>
                    <NewsImage
                        component="img"
                        image={item.imgSrc}
                        alt="News image"
                    />
                    <StyledCardContent>
                        <NewsTitle variant="h5" component="h2">
                            <RouterLink to={item.link} style={{ textDecoration: 'none', color: 'inherit' }}>
                                {item.title}
                            </RouterLink>
                        </NewsTitle>
                        <Typography variant="subtitle1" color="text.secondary" component="div">
                            {item.content}
                            <ReadMoreLink to={item.link}>
                                Read More <ArrowForwardIcon sx={{ fontSize: '1rem', ml: 0.3 }} />
                            </ReadMoreLink>
                        </Typography>

                        <Box sx={{ display: isMobile ? 'block' : 'flex', justifyContent: isMobile ? 'initial' : 'space-between', my: 5, fontSize: '0.875rem' }}>
                            <Typography>{formatDateSimple(item.date)}</Typography>
                            <Typography sx={{ fontWeight: 'bold', mt: isMobile ? 1 : 'none' }}>{item.category}</Typography>
                        </Box>

                    </StyledCardContent>
                </StyledCard>
            ))}

            <Box sx={{ mt: 4, textAlign: 'center' }}>
                <StyledButton variant="outlined" component={RouterLink} to="/news">
                    See More News
                </StyledButton>
            </Box>
        </Box>
    );
};

export default RecentNewsHome;
